// Plantillas de evoluciones clínicas — texto base que el odontólogo puede insertar
// y luego personalizar. Pensadas para procedimientos comunes en Colombia.

export const EVOLUTION_TEMPLATES = [
  {
    key: "valoracion",
    label: "Valoración inicial",
    diagnostico: "Examen clínico de ingreso",
    procedimiento:
      "Anamnesis completa. Examen extraoral e intraoral. Diligenciamiento de odontograma y periodontograma. " +
      "Toma de fotografías clínicas. Se explica al paciente el plan de tratamiento sugerido y se entrega presupuesto.",
    observaciones: "Paciente acepta el plan de tratamiento propuesto.",
  },
  {
    key: "profilaxis",
    label: "Profilaxis (limpieza dental)",
    diagnostico: "Cálculo y placa bacteriana supragingival",
    procedimiento:
      "Profilaxis con ultrasonido y puntas finas. Detartraje supragingival completo en ambas arcadas. " +
      "Pulido coronal con copa de caucho y pasta profiláctica. Aplicación tópica de flúor neutro 2% por 4 minutos.",
    observaciones:
      "Se entregan instrucciones de higiene oral. Cita de control en 6 meses. " +
      "No ingerir alimentos ni bebidas durante 30 minutos.",
  },
  {
    key: "detartraje",
    label: "Raspaje y alisado radicular",
    diagnostico: "Periodontitis crónica leve a moderada",
    procedimiento:
      "Anestesia infiltrativa por cuadrante. Raspaje y alisado radicular subgingival con curetas Gracey. " +
      "Lavado con clorhexidina 0.12%. Pulido final.",
    observaciones:
      "Se prescribe enjuague con clorhexidina por 7 días. Reevaluación periodontal en 4-6 semanas.",
  },
  {
    key: "resina",
    label: "Restauración con resina compuesta",
    diagnostico: "Caries dental clase __ (especificar Black)",
    procedimiento:
      "Anestesia infiltrativa. Aislamiento absoluto con dique de goma. " +
      "Eliminación de tejido cariado con fresa redonda de carburo. Grabado ácido con ortofosfórico al 37% por 15 seg, " +
      "lavado y secado. Aplicación de adhesivo y fotocurado. Restauración con resina compuesta por capas, fotocurado " +
      "por capa. Ajuste oclusal con papel de articular. Pulido final con discos y gomas.",
    observaciones: "Paciente tolera bien el procedimiento. Sin sensibilidad postoperatoria al momento del alta.",
  },
  {
    key: "sellante",
    label: "Sellante de fosas y fisuras",
    diagnostico: "Fosas y fisuras profundas sin caries",
    procedimiento:
      "Profilaxis del diente con copa y piedra pómez. Aislamiento relativo con rollos de algodón. " +
      "Grabado ácido por 20 segundos, lavado y secado. Aplicación de sellante resinoso fluido y fotocurado por 20 seg. " +
      "Verificación oclusal.",
    observaciones: "Indicado control radiográfico anual.",
  },
  {
    key: "endo_uni",
    label: "Endodoncia uniradicular",
    diagnostico: "Pulpitis irreversible / necrosis pulpar",
    procedimiento:
      "Anestesia infiltrativa. Aislamiento absoluto. Acceso cameral con fresa redonda y Endo-Z. " +
      "Localización de conducto. Conductometría con localizador apical confirmada radiográficamente. " +
      "Instrumentación rotatoria con sistema ProTaper hasta lima F2. Irrigación abundante con hipoclorito de sodio 5.25% " +
      "y EDTA 17%. Secado con conos de papel. Obturación con técnica de condensación lateral con conos de gutapercha y " +
      "cemento sellador. Restauración temporal con coltosol.",
    observaciones:
      "Se cita en 7 días para retirar provisional y restauración definitiva. Se prescribe analgésico si requiere.",
  },
  {
    key: "endo_multi",
    label: "Endodoncia multirradicular (molar)",
    diagnostico: "Pulpitis irreversible / necrosis pulpar molar",
    procedimiento:
      "Anestesia troncular. Aislamiento absoluto. Acceso cameral, ubicación e instrumentación de los " +
      "conductos MV, ML, DV, DL/Palatino. Conductometría con localizador apical confirmada. Instrumentación rotatoria. " +
      "Irrigación con hipoclorito 5.25% y EDTA. Obturación tridimensional. Sellado provisional.",
    observaciones: "Cita de control en 7 días para reconstrucción definitiva. Recomendar corona protésica.",
  },
  {
    key: "ext_simple",
    label: "Exodoncia simple",
    diagnostico: "Diente no restaurable / indicación protésica",
    procedimiento:
      "Anestesia infiltrativa. Sindesmotomía con periostotomo. Luxación con elevadores rectos y curvos. " +
      "Extracción con fórceps adecuado al diente. Curetaje del alvéolo. Compresión digital de tablas. " +
      "Sutura si requiere. Hemostasia con gasa.",
    observaciones:
      "Indicaciones postoperatorias verbales y escritas: morder gasa por 30 min, dieta blanda fría 24h, " +
      "no escupir ni enjuagar el primer día, no fumar. Analgésico cada 8 horas si dolor.",
  },
  {
    key: "ext_quir",
    label: "Exodoncia quirúrgica (tercer molar)",
    diagnostico: "Tercer molar incluido / semi-incluido",
    procedimiento:
      "Anestesia troncular. Incisión y levantamiento de colgajo mucoperióstico. Osteotomía con fresa quirúrgica " +
      "bajo irrigación abundante con suero fisiológico. Odontosección si se requiere. Luxación y avulsión. " +
      "Curetaje del alveolo. Lavado con suero. Sutura con seda 3-0.",
    observaciones:
      "Se prescribe Amoxicilina 500 mg c/8h por 7 días e Ibuprofeno 600 mg c/8h. " +
      "Aplicación local de hielo intermitente las primeras 24h. Retiro de suturas en 7 días.",
  },
  {
    key: "blanqueamiento",
    label: "Blanqueamiento dental en consultorio",
    diagnostico: "Discromía dental — solicitud estética",
    procedimiento:
      "Profilaxis previa. Aislamiento de tejidos blandos con barrera gingival fotopolimerizable. " +
      "Aplicación de peróxido de hidrógeno al 35% por dos sesiones de 15 minutos cada una. " +
      "Retiro del agente, lavado y aplicación de desensibilizante.",
    observaciones:
      "Evitar alimentos pigmentantes (café, vino, té, tabaco) por 48 horas. Posible sensibilidad pasajera.",
  },
  {
    key: "corona_cementacion",
    label: "Cementación de corona",
    diagnostico: "Diente preparado para corona protésica",
    procedimiento:
      "Retiro de provisional. Limpieza del muñón con piedra pómez. Prueba de la corona definitiva: ajuste " +
      "marginal, oclusión y estética verificados. Cementación con cemento de ionómero de vidrio modificado con resina. " +
      "Eliminación de excesos. Verificación oclusal final.",
    observaciones: "Higiene cuidadosa del margen gingival. Control en 1 mes.",
  },
  {
    key: "ortodoncia_control",
    label: "Control de ortodoncia",
    diagnostico: "Tratamiento de ortodoncia en curso",
    procedimiento:
      "Revisión general del aparato. Cambio de ligas elásticas. Activación del arco. " +
      "Refuerzo de instrucciones de higiene y manejo de elásticos.",
    observaciones: "Próxima cita en 30 días.",
  },
  {
    key: "fluorizacion",
    label: "Aplicación de flúor",
    diagnostico: "Prevención de caries",
    procedimiento:
      "Profilaxis previa. Aislamiento relativo. Aplicación de flúor neutro al 2% en cubetas durante 4 minutos.",
    observaciones: "No comer ni beber durante 30 minutos.",
  },
  {
    key: "pulpotomia",
    label: "Pulpotomía (diente temporal)",
    diagnostico: "Caries profunda con compromiso pulpar — diente temporal",
    procedimiento:
      "Anestesia infiltrativa. Aislamiento absoluto. Eliminación de caries y techo cameral. Amputación pulpar " +
      "coronal con cucharilla. Hemostasia con torunda humedecida en formocresol por 5 min. Aplicación de pasta de óxido " +
      "de zinc-eugenol. Restauración con ionómero de vidrio.",
    observaciones: "Control radiográfico en 3 meses.",
  },
  {
    key: "urgencia_dolor",
    label: "Urgencia — manejo del dolor",
    diagnostico: "Dolor agudo (especificar etiología)",
    procedimiento:
      "Anestesia. Apertura cameral / drenaje de absceso según hallazgo clínico-radiográfico. " +
      "Lavado con hipoclorito. Medicación intracanal con hidróxido de calcio. Sellado provisional.",
    observaciones:
      "Se prescribe analgésico y antibiótico según indicación. Cita programada en 48-72 horas para tratamiento definitivo.",
  },
];
